<template>
<!-- 老学员成绩单-选择讯息 -->
    <div class="school-card-form">
        <div class="head-img">
            <img :src="item.headimgurl" alt="">
        </div>
        <!--  -->
        <div class="school-main">
            <div class="group-s">
                <img class="text1" src="@a/other/report_card_poster/text1.png" alt="">
                <input v-model="form.text1" class="inp"  />
            </div>
            <!--  -->
            <div class="group-s">
                <img class="text2" src="@a/other/report_card_poster/text2.png" alt="">
                <div>
                    <input v-model="form.text2" class="inp" type="text"    />
                    <img class="text2-2" src="@a/other/report_card_poster/text3.png" alt="">
                </div>
            </div>
            <!--  -->
            <div class="group-s">
                <img class="text4" src="@a/other/report_card_poster/text4.png" alt="">
                <div @click="form.text3='志同道合的伙伴'" class="select">
                    1.志同道合的伙伴
                    <span class="checkbox"></span>
                    <img v-if="form.text3=='志同道合的伙伴'" class="check" src="@a/other/report_card_poster/icon1.png" alt="">
                </div>
                <div @click="form.text3='副业变现的技能'" class="select">
                    2.副业变现的技能
                    <span class="checkbox"></span>
                    <img v-if="form.text3=='副业变现的技能'" class="check" src="@a/other/report_card_poster/icon1.png" alt="">
                </div>
                <div @click="form.text3='实用的生涯知识'" class="select">
                    3.实用的生涯知识 
                    <span class="checkbox"></span>
                    <img v-if="form.text3=='实用的生涯知识'" class="check" src="@a/other/report_card_poster/icon1.png" alt="">
                </div>
                <div @click="form.text3='一份满意的工作'" class="select">
                    4.一份满意的工作
                    <span class="checkbox"></span>
                    <img v-if="form.text3=='一份满意的工作'" class="check" src="@a/other/report_card_poster/icon1.png" alt="">
                </div>
            </div>
            <!--  -->
            <div class="group-s">
                <img class="text5" src="@a/other/report_card_poster/text5.png" alt="">
                <div>
                    <div readonly   class="inp box" type="text"   >{{form.text4}}</div>
                    <img @click="randomVersion()" class="icon" src="@a/other/report_card_poster/icon2.png" alt="">
                </div>
            </div>
            <!-- btn -->
            <button @click="createPoster()" class="btn">
                生成海报
                <!-- <img src="@a/other/report_card_poster/schb.png" alt=""> -->
            </button>
        </div>
        <!-- 海报生成的内容 -->
        <div v-if="showPoster" class="poster-pop">
            <img :src="posterLink" alt="">
            <div class="btn-group">
                <button @click="showPoster=false" class="btn">修改内容</button>
                <button @click="tabPoster()" class="btn">换一换</button>
            </div>
        </div>
    </div>
</template>

<script>
import { userInfo,createPoster } from '@/api/other'
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            item:{},
            form:{
                text1:'',
                text2:'',
                text3:'',
                text4:'',
                version:null
            },
            version:['实现高手的跃迁','拆掉思维里的墙','寻找生命可能性'],
            idx:0,
            // 海报显示
            showPoster:false,
            posterLink:''
        }
    },
    methods:{
        // 切换海报
        tabPoster(){
            this.randomVersion(true);
            this.createPoster();
        },
        // 生成海报
        createPoster(){
            let keys = Object.keys(this.form);
            if(keys){
                for(let i=0;i<keys.length;i++){
                    if(!this.form[keys[i]]){
                        console.log(keys[i])
                        this.$toast('请填写完整信息！');
                        return
                    }
                }
            }
            //调用加载中
            this.$emit('loadingHandle',true,"海报生成中...");
            createPoster({
                poster:'report_card_2020',
                params:this.form
            }).then((data)=>{
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                this.posterLink = data.image_url;
                this.showPoster = true;
            });

        },
        // 切换海报版本
        randomVersion(bool){
            // this.$forceUpdate();
            if(this.idx==2){
                this.idx = 0;
            }else{
                this.idx+=1;
            }
            this.form.version = this.idx+1;
            if(!bool){
                this.form.text4 = this.version[this.idx];
            }
            
        },
        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            userInfo().then((data)=>{
                document.title = '新精英“ 老学员成绩单 ”';
                //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail);
                    return
                }
                this.form.text4 = this.version[this.idx];
                this.form.version = this.idx+1;
                this.item = data;
                shareCon("index", this);
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.school-card-form{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../../../assets/other/report_card_poster/form-bg.png') center no-repeat;
    background-size: cover;
    .head-img{
        background: url('../../../assets/other/report_card_poster/form-border.png') center no-repeat;
        padding: 5px;
        // border:5px solid #FEF280;
        background-color: #FEF280;
        background-size: 100% 100%;
        margin: 208px auto auto 180px;
        border-radius: 50%;
        width: 185px;
        text-align: center;
        height: 185px;
        display: flex;
        align-items: center;
        img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    .school-main{
        margin: 40px auto auto 180px;
        display: flex;
        flex-direction: column;
        .group-s{
            display: flex;
            flex-direction: column;
            margin-bottom: 32px;
            &:last-of-type{
                margin-bottom: 46px;
            }
            .text1{
                width: 60px;
            }
            .text2{
                width: 250px;
            }
            .text2-2{
                width: 30px;
            }
            .text4{
                width: 280px;
            }
            .text5{
                width: 295px;
            }
            .inp{
                width: 380px;
                box-sizing: border-box;
                height: 46px;
                background: #FEF280;
                box-shadow: 0px 0px 13px 8px rgba(255, 137, 14, 0.35) inset;
                border-radius: 6px;
                border: none;
                font-weight: 500;
                margin-top: 12px;
                padding-left: 20px;
                color: #CA461A;
                margin-right: 20px;
            }
            .inp.box{
                display: inline-block;
                vertical-align: bottom;
                line-height: 46px;
            }
            .select{
                position: relative;
                width: 380px;
                height: 46px;
                line-height: 46px;
                background: #FEF280;
                box-shadow: 0px 0px 13px 8px rgba(255, 137, 14, 0.35) inset;
                border-radius: 6px;
                font-weight: 500;
                padding-left: 20px;
                color: #CA461A;
                margin-bottom: 10px;
                &:first-of-type{
                    margin-top: 12px;
                }
                &:last-of-type{
                    margin-bottom: 0;
                }
                .checkbox{
                    position: absolute;
                    width: 27px;
                    height: 27px;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    display: block;
                    border-radius: 6px;
                    background-color: #000000;
                    z-index: 2;
                }
                .check{
                    position: absolute;
                    width: 35px;
                    // height: 27px;
                    right: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    z-index: 3;
                }
            }
            .icon{
                width: 36px;
                height: 36px;
            }
        }
        .btn{
            border: none;
            width: 380px;
            height: 66px;
            line-height: 66px;
            background: #000000;
            box-shadow: 0px 0px 13px 8px rgba( #FEF280, 0.35);
            border-radius: 33px;
            // padding-bottom: 10px;
            font-size: 36px;
            color: #FEF280;
            font-weight: bold;
            // img{
            //     width: 152px;
            //     height: 34px;
            //     line-height: 34px;
            //     margin-bottom: 7px;
            // }
        }
    }
    .poster-pop{
        position: absolute;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 750px;
        height: 100%;
        transform: translateX(-50%);
        background: url('../../../assets/other/report_card_poster/form-bg.png') center no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 77;
        img{
            margin:314px auto 60px;
            width: 425px;
        }
        .btn-group{
            display: flex;
            justify-content: space-between;
            .btn{
                width: 209px;
                height: 66px;
                background: #FEF280;
                border: none;
                box-shadow: 0px 0px 13px 8px rgba( #FEF280, 0.35);
                border-radius: 33px;
                font-size: 32px;
                color: #CA461A;
                font-weight: bold;
                &:first-of-type{
                    margin-right: 16px;
                }
            }
        }
    }
}
</style>